import styled from 'styled-components'

export const ScrollableDiv = styled.div`
  overflow-y: auto;
  box-sizing: border-box;
  scrollbar-gutter: stable;
  /* Hide scrollbar by default */
  &::-webkit-scrollbar {
    width: 3px;
    height: 8px;
  }

  /* Optional: Customize scrollbar track and thumb */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    transition: all 0.3s ease-in-out;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`
